<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const LOCALE_STORAGE_KEY = 'app_locale'

const { locale, t } = useI18n()

const languages = computed(() => [
  { code: 'ru', name: t('russian') },
  { code: 'en', name: t('english') },
  { code: 'zh', name: t('chinese') },
])

const currentLocale = computed(() => locale.value)

function changeLanguage(langCode: string) {
  locale.value = langCode
  localStorage.setItem(LOCALE_STORAGE_KEY, langCode)
}
</script>

<template>
  <ElDropdown trigger="click" :teleported="false" placement="bottom-end">
    <span
      class="el-dropdown-link flex items-center gap-1.5 cursor-pointer p-2 rounded-lg hover:bg-gray-100 transition-colors"
    >
      <i class="icon-global text-xl text-text-secondary" />
      <span class="text-sm font-medium text-text-secondary uppercase">
        {{ currentLocale }}
      </span>
      <i class="icon-chevron-down text-lg text-text-secondary" />
    </span>
    <template #dropdown>
      <ElDropdownMenu>
        <ElDropdownItem
          v-for="lang in languages"
          :key="lang.code"
          :class="{ 'is-active': currentLocale === lang.code }"
          @click="changeLanguage(lang.code)"
        >
          <div class="flex items-center gap-2">
            <span>{{ lang.name }}</span>
            <i
              v-if="currentLocale === lang.code"
              class="icon-tick text-xl text-primary ml-auto"
            />
          </div>
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<style scoped>
:deep(.el-dropdown-menu__item.is-active) {
  background-color: #f5f7fa;
}
</style>
